import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useQuery } from 'react-query';
import {
  Card, Spin, Typography,
} from 'antd';
import {
  ClockCircleOutlined,
} from '@ant-design/icons';

import QartodLabel from '../QartodLabel';
import { getQartodConfiguration } from '../../../../services/dataset.service';

const QartodCard = (props) => {
  const {
    isLoading, data, timestamp, parameter, obsDataV2, parameterConfigurationsResult,
  } = props;

  const {
    data: qartodConfiguration,
  } = useQuery(
    ['qartod-configuration'],
    () => getQartodConfiguration(),
  );

  console.log('QartodCard timestamp', timestamp);

  const getParameterQartodConfig = (parameter, config) => {
    if (!parameter || !config || !parameter.name_vocabulary || Object.keys(config).length === 0) {
      return null;
    }

    const vocab = parameter.name_vocabulary;
    const name = parameter.standard_name;
    return config?.[vocab]?.[name] || null;
  };

  const grossRangeTestResult = data?.filter((q) => q.test === 'gross_range_test_quality_flag')?.pop()?.result;
  const flatLineTestResult = data?.filter((q) => q.test === 'flat_line_test_quality_flag')?.pop()?.result;
  const spikeTestResult = data?.filter((q) => q.test === 'spike_test_quality_flag')?.pop()?.result;
  const rateOfChangeTestResult = data?.filter((q) => q.test === 'rate_of_change_test_quality_flag')?.pop()?.result;

  const parameterQartodConfig = getParameterQartodConfig(parameter, qartodConfiguration);

  const tsIndex = obsDataV2?.timestamps?.indexOf(timestamp);
  const parameterObs = obsDataV2?.parameter_obs?.values?.[parameter?.parameter_id];
  const obsValue = parameterObs ? parameterObs[tsIndex] : undefined;

  const parameterConfig = parameterConfigurationsResult?.find((param) => param.standard_name === parameter.standard_name);
  const canonicalUnit = parameterConfig?.units.find((u) => u.id === parameterConfig.canonical_unit_id);

  return (
    <Card
      // variant="borderless"
      bordered={false}
      title={(
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          QARTOD
          {isLoading ? (
            <Spin />
          ) : (
            <div
              style={{
                fontWeight: 400,
                fontSize: 14,
                display: 'flex',
                gap: 6,
                alignItems: 'center',
              }}
            >
              <ClockCircleOutlined
                color="#748D9C"
              />
              {moment.unix(timestamp).fromNow()}
            </div>
          )}
        </div>
      )}
      style={{
        backgroundColor: '#03304b', // TODO: replace with brand var
        border: '1px solid #4f6f81',
        color: 'white',
      }}
    >
      <div
        style={{
          color: '#A7B7C0',
          borderBottom: '1px solid #4F6E81',
          paddingBottom: 10,
          fontSize: 13,
        }}
      >
        Click a data point to view individual QARTOD results for each observation.
      </div>
      {/* TODO: show aggregate */}
      {/* TODO: abstract to component */}
      <div
        style={{
          borderBottom: '1px solid #4F6E81',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography.Title level={5} style={{ color: '#D9E0E4', marginBottom: 0 }}>
            Raw Observation
          </Typography.Title>
          {obsValue && canonicalUnit?.symbol && (
            <>
              {obsValue}
              {canonicalUnit?.symbol}
            </>
          )}
        </div>
      </div>
      <div
        style={{
          borderBottom: '1px solid #4F6E81',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography.Title level={5} style={{ color: '#D9E0E4', marginBottom: 0 }}>
            Gross Range
          </Typography.Title>
          <QartodLabel result={grossRangeTestResult} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
            color: '#D9E0E4',
          }}
        >
          <span>
            Fail Span
          </span>
          <span>
            {parameterQartodConfig?.qartod?.gross_range_test?.fail_span?.join(' to ')}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <span>
            Suspect Span
          </span>
          <span>
            {parameterQartodConfig?.qartod?.gross_range_test?.suspect_span?.join(' to ')}
          </span>
        </div>
      </div>
      <div
        style={{
          borderBottom: '1px solid #4F6E81',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography.Title level={5} style={{ color: '#D9E0E4', marginBottom: 0 }}>
            Spike Test
          </Typography.Title>
          <QartodLabel result={spikeTestResult} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
            color: '#D9E0E4',
          }}
        >
          <span>
            Fail Threshold
          </span>
          <span>
            {parameterQartodConfig?.qartod?.spike_test?.fail_threshold}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <span>
            Suspect Threshold
          </span>
          <span>
            {parameterQartodConfig?.qartod?.spike_test?.suspect_threshold}
          </span>
        </div>
        {/* TODO: show these in user units */}
      </div>

      <div
        style={{
          borderBottom: '1px solid #4F6E81',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography.Title level={5} style={{ color: '#D9E0E4', marginBottom: 0 }}>
            Rate of Change
          </Typography.Title>
          <QartodLabel result={rateOfChangeTestResult} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <span>
            Threshold
          </span>
          <span>
            {parameterQartodConfig?.qartod?.rate_of_change_test?.threshold}
          </span>
        </div>
      </div>

      <div
        style={{
          paddingTop: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography.Title level={5} style={{ color: '#D9E0E4', marginBottom: 0 }}>
            Flat Line
          </Typography.Title>
          <QartodLabel result={flatLineTestResult} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
            color: '#D9E0E4',
          }}
        >
          <span>
            Fail Threshold
          </span>
          <span>
            {parameterQartodConfig?.qartod?.flat_line_test?.fail_threshold}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
            color: '#D9E0E4',
          }}
        >
          <span>
            Suspect Threshold
          </span>
          <span>
            {parameterQartodConfig?.qartod?.flat_line_test?.suspect_threshold}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
            color: '#D9E0E4',
          }}
        >
          <span>
            Tolerance
          </span>
          <span>
            {parameterQartodConfig?.qartod?.flat_line_test?.tolerance}
          </span>
        </div>
      </div>

    </Card>
  );
};

QartodCard.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  timestamp: PropTypes.number,
  parameter: PropTypes.object,
  obsDataV2: PropTypes.array,
  parameterConfigurationsResult: PropTypes.array,
};

QartodCard.defaultProps = {
  data: undefined,
  isLoading: false,
  timestamp: undefined,
  parameter: undefined,
  obsDataV2: undefined,
  parameterConfigurationsResult: [],
};

export default QartodCard;
